import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Eye, CheckCircle2 } from "lucide-react";

const fmt = (iso) => new Date(iso).toLocaleString(undefined, { weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });

export function AccessReceiptsCard() {
  const [data, setData] = useState(null);
  const [showAll, setShowAll] = useState(false);
  useEffect(() => { api.get("/me/access-receipts").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return null;
  const list = showAll ? data.receipts : data.receipts.slice(0, 8);

  return (
    <div className="warm-card p-6 space-y-3" data-testid="access-receipts-card">
      <div className="flex items-start gap-3">
        <Eye className="w-6 h-6 text-emerald-700 mt-0.5" />
        <div>
          <h3 className="font-display text-lg font-bold text-stone-900">Who has looked at your record</h3>
          <p className="text-sm text-stone-600 mt-0.5">Every time your coach opens, exports or runs a report on your information it's recorded here — the last 90 days, most recent first. Nobody else can see your record.</p>
        </div>
      </div>
      {data.count === 0 ? (
        <p className="text-sm text-emerald-800 inline-flex items-center gap-1.5" data-testid="access-receipts-empty"><CheckCircle2 className="w-4 h-4" /> No one has viewed your record in the last 90 days.</p>
      ) : (
        <>
          <ul className="divide-y divide-stone-100" data-testid="access-receipts-list">
            {list.map((r, i) => (
              <li key={`${r.at}-${i}`} className="py-2 text-sm flex items-start justify-between gap-3" data-testid={`access-receipt-${i}`}>
                <span className="text-stone-800"><strong>{r.clinician}</strong> {r.what}</span>
                <span className="text-xs text-stone-500 font-mono whitespace-nowrap">{fmt(r.at)}</span>
              </li>
            ))}
          </ul>
          {data.receipts.length > 8 && (
            <button data-testid="access-receipts-toggle" onClick={() => setShowAll((s) => !s)} className="text-xs font-semibold text-amber-800 hover:text-amber-900">
              {showAll ? "Show fewer" : `Show all ${data.count}`}
            </button>
          )}
        </>
      )}
    </div>
  );
}
